angular
	.module 'App.Module.ProductFilter', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'product_filter',
				url: '/product_filters',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@product_filter':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'ProductFilterRepository'
						title: 'general.product_filters'
					restrict: 'Shared.Setting.ProductFilter.Enabled'

			.state 'product_filter.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					productFilter: (ProductFilterRepository, $stateParams) ->
						return ProductFilterRepository.getEntity $stateParams.id

			.state 'product_filter.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'ProductFilterController'
						controllerAs: 'vm'
						templateUrl: '@app/product-filter/product-filter.view.html'
